import axios from 'axios';

const BASE_URL = `${process.env.VUE_APP_API_ROOT}/configAnnotation`;

export interface FileStats {
  size: number;
  created: string;
  modified: string;
}

export interface FileItem {
  filename: string;
  size: number;
  created: string;
  modified: string;
  url: string;
}

export const jsonService = {
  async upload(base64Data: string): Promise< any | undefined> {
    const res = await axios.post(`${BASE_URL}`, {
      base64: base64Data
    });

    return res.data;
  },

  async get(): Promise<{ data: any; fileStats: FileStats }> {
    const res = await axios.get(`${BASE_URL}`);
    return res.data;
  },

  async delete(): Promise<{ message: string }> {
    const res = await axios.delete(`${BASE_URL}`);
    return res.data;
  },
};